import React, { useState, Suspense, useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import logo from "../assets/images/logo.png";
import { useAuth } from './AuthContext';
import '../styles/Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCog, faSignOutAlt, faBars, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import BirthCertificate from './Birthcert';
import DeathCertificate from './Deathcert';
import MarriageCertificate from './Marriagecert';
import LocalCertificateList from './localcertlist';
import LocalCertLedger from './localcertledger';
import Localdomlist from './localdomlist';
import LocalDomLedger from './localdomledger';
import BirthCertificateList from './Birthcertlist';
import BirthCertLedger from './Birthcertledger';
import DeathCertificateList from './Deathcertlist';
import DeathCertLedger from './Deathcertledger';
import MarriageCertificateList from './Marriagecertlist';
import MarriageCertLedger from './Marriagecertledger';
import ArmsListForm from './armslist';
import ArmsLedger from './armsledger';
import GDSRForm from './GeneralDSR';
import GDSRList from './GDSRList';
import GDSRLedger from './gdsrledger';
import SDSRForm from '../pages/SpecailDSR';
import SDSRList from './SDSRList';
import SDSRLedger from './sdsrledger';
import Passport from './Passcert';
import PassportList from './Passcertlist';
import PassportLedger from './Passcertledger';
import ComplaintList from './ComplaintsTable';
import FIRForm from './FIR';
import FIRList from './FIRlist';
import ChallanList from './Challanlist';
import FIRLedger from './FIRledger';
import SChallanLedger from './sChallanLedger';
import EditArmsf from './Editarms';
import AnnouncementForm from './AnnouncementForm';

// Lazy load submenu pages
const Blank = React.lazy(() => import('../pages/localdomblank'));
const Arms = React.lazy(() => import('./arms'));
const LocalCertificateForm = React.lazy(() => import('./Localcertificate'));
const LocalDomicileForm = React.lazy(() => import('./Localdomicile'));

const Dashboard = () => {
    const { user, setUser } = useAuth();
    const [activeMenu, setActiveMenu] = useState('');
    const [activeSubmenu, setActiveSubmenu] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const navigate = useNavigate();

    // Handle screen size changes to adjust sidebar state
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setSidebarOpen(true);  // Open sidebar on large screens
            } else {
                setSidebarOpen(false); // Close sidebar on small screens
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Call on initial render to set the correct sidebar state

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('user');
        navigate('/Login');
    };

    const menus = [
        {
            name: "E-Domicile",
            submenus: [
                { name: "Domicile Form", component: <LocalDomicileForm /> },
                { name: "Domicile List", component: <Localdomlist /> },
                { name: "Domicile Ledger", component: <LocalDomLedger /> },
            ],
        },
    ];

    const handleMenuClick = (menuName) => {
        setActiveMenu((prev) => (prev === menuName ? '' : menuName));
        setActiveSubmenu('');
    };

    // const handleSubmenuClick = (submenuName) => {
    //     setActiveSubmenu(submenuName);
    // };

    const handleSubmenuClick = (submenuName) => {
        setActiveSubmenu(submenuName);
    
        // Close sidebar on small screens
        if (window.innerWidth <= 768) {
            setSidebarOpen(false);
        }
    };
    const renderContent = () => {
        const activeMenuData = menus.find((menu) => menu.name === activeMenu);
        const activeSubmenuData = activeMenuData?.submenus.find((submenu) => submenu.name === activeSubmenu);
        return activeSubmenuData?.component || <Blank />;
    };

    return (
        <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <aside className="dashboard-sidebar">
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src={logo} alt="E-AC Logo" className={`logo ${!sidebarOpen ? 'logo-small' : ''}`} />
                        <h2 className="sidebar-title">{sidebarOpen ? 'E-AC | Dashboard' : ''}</h2>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    <ul>
                        <li>
                            <a
                                className={`nav-link ${activeMenu === '' ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveMenu('');
                                    setActiveSubmenu('');
                                }}>
                                <FontAwesomeIcon icon={faHome} />
                                {sidebarOpen && <span className="menu-label">Dashboard</span>}
                            </a>
                        </li>
                        {menus.map((menu) => (
                            <li key={menu.name}>
                                <a
                                    className={`nav-link ${activeMenu === menu.name ? 'active' : ''}`}
                                    onClick={() => sidebarOpen && handleMenuClick(menu.name)}>
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    {sidebarOpen && <span className="menu-label">{menu.name}</span>}
                                </a>
                                {activeMenu === menu.name && sidebarOpen && (
                                    <div className="submenu-box">
                                        {menu.submenus.map((submenu) => (
                                            <a
                                                key={submenu.name}
                                                className={`submenu-link ${activeSubmenu === submenu.name ? 'active' : ''}`}
                                                onClick={() => handleSubmenuClick(submenu.name)}>
                                                <div className="submenu-line"></div>
                                                {submenu.name}
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
            <main className="dashboard-main">
                <header className="main-header">
                    <button className="toggle-sidebar-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                    {/* <h1>Welcome, {user?.username || 'User'}</h1> */}
                    <div className="breadcrumb">
                        <span>Dashboard</span>
                        {activeMenu && <span> / {activeMenu}</span>}
                        {activeSubmenu && <span> / {activeSubmenu}</span>}
                    </div>
                    {/* <button className="logout-btn" onClick={handleLogout}>
                        <FontAwesomeIcon icon={faSignOutAlt} />
                    </button> */}
                </header>
                <section className="main-content">
                    <Suspense fallback={<div>Loading...</div>}>{renderContent()}</Suspense>
                </section>
            </main>
            <Routes>
                <Route path="edit-arms-license" element={<EditArmsf />} />
            </Routes>
        </div>
    );
};

export default Dashboard;